<div class="border-b border-slate-200 mb-6">
  <nav class="flex gap-6" aria-label="Tabs">
    @for (usage of pluginUsages(); track usage.id) {
    <button
      type="button"
      class="tab-btn text-sm font-medium pb-3 border-b-2 transition-colors"
      [ngClass]="{
          'text-blue-600 border-blue-600': activePluginUsageId() === usage.id,
          'text-slate-500 border-transparent': activePluginUsageId() !== usage.id
        }"
      (click)="setActiveTab(usage.id)"
    >
      {{ getPluginDisplayName(usage.plugin_id) }}
    </button>
    }
  </nav>
</div>
<div class="p-5 bg-white rounded-xl border border-slate-200 shadow-sm mb-6">
  @for (usage of pluginUsages(); track usage.id) { @if (activePluginUsageId()
  === usage.id) {
  <app-plugin-usage-detail
    [entityId]="usage.id"
    [surveyPlugins]="surveyPlugins()"
  ></app-plugin-usage-detail>
  } }
</div>
